import type { IFeatureTreeState } from './Redux/FeatureTree/types';
import type { ISecurityGroupsState } from './Redux/SecurityGroups/types';

export type AccessGateRestriction = 'role' | 'geo' | 'error' | null;

export function isAccessGatePending(
  securityGroupsState: ISecurityGroupsState | undefined,
  featureTreeState: IFeatureTreeState | undefined
): boolean {
  const securityGroups = securityGroupsState?.groups ?? null;
  const areSecurityGroupsPending =
    securityGroupsState == null ||
    securityGroupsState.isLoading ||
    (securityGroups == null && !securityGroupsState.hasError);

  if (areSecurityGroupsPending) {
    return true;
  }

  const shouldResolveFeatureTree = securityGroups != null && securityGroups.length > 0;
  return (
    shouldResolveFeatureTree &&
    (featureTreeState == null ||
      featureTreeState.isLoading ||
      (featureTreeState.tree == null && !featureTreeState.hasError))
  );
}

export function getAccessGateRestriction(
  securityGroupsState: ISecurityGroupsState | undefined,
  featureTreeState: IFeatureTreeState | undefined
): AccessGateRestriction {
  if (securityGroupsState?.hasError) {
    return 'error';
  }

  const securityGroups = securityGroupsState?.groups ?? null;
  if (securityGroups !== null && securityGroups.length === 0) {
    return 'role';
  }

  if (featureTreeState?.isAccessDenied) {
    return 'role';
  }

  if (featureTreeState?.isGeoBlocked) {
    return 'geo';
  }

  if (featureTreeState?.hasError) {
    return 'error';
  }

  return null;
}
